import { withRouter } from 'react-router-dom';
import React, {
    useEffect, useState
} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { StepProgressBar } from '@jutro/components';
import messages from './NewServiceWizardStepsComponent_AX.messages';

function NewServiceWizardStepsComponentAX(props) {
    const {
        onEnterStep1,
        onEnterStep2,
        currentStep
    } = props;

    const [visitedSteps, updateVisitedSteps] = useState([1]);
    const [steps, updateSteps] = useState([]);

    useEffect(() => {
        updateSteps([
            {
                active: currentStep === 1,
                onClick: function onStepClicked() {
                    const canProceed = onEnterStep1();
                    if (canProceed) {
                        updateVisitedSteps([1]);
                    }
                },
                title: messages.step1Title,
                visited: visitedSteps.includes(1)
            },
            {
                active: currentStep === 2,
                onClick: function onStepClicked() {
                    const canProceed = onEnterStep2();
                    if (canProceed) {
                        updateVisitedSteps([1, 2]);
                    }
                },
                title: messages.step2Title,
                visited: visitedSteps.includes(2)
            }
        ]);
    }, [currentStep, onEnterStep1, onEnterStep2, visitedSteps]);

    return (
        <StepProgressBar
            steps={steps}
            isVertical={false}
        />
    );
}

NewServiceWizardStepsComponentAX.propTypes = {
    onEnterStep1: PropTypes.func,
    onEnterStep2: PropTypes.func
};

NewServiceWizardStepsComponentAX.defaultProps = {
    onEnterStep1: _.noop,
    onEnterStep2: _.noop
};

export default withRouter(NewServiceWizardStepsComponentAX);
